import {
    type ChangeMailResponseType,
    type ChangeMailPayloadType
} from "./type";
import md5 from "md5";
import {
    request
} from "../request";

const ChangeMail = async (payload: ChangeMailPayloadType): Promise<ChangeMailResponseType> => {
    return await request<ChangeMailResponseType>("/auth/changeMail", {
        body: JSON.stringify({
            password: md5(payload.password),
            newMail: payload.newMail
        }),
        method: "POST"
    });
};

export default ChangeMail;
